import * as React from 'react';

export function SvgChevronsRight() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="-2 -2 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="m6.78.97 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06L9.69 6 5.72 2.03zm-4.75 0 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5L.97 9.97 4.94 6 .97 2.03z"
          clipRule="evenodd"
        />
      </svg>
    </span>
  );
}
